import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import * as toastr from 'toastr';
import {ProviderModel} from '../../../../models/ProviderModel';
import {ProviderAnagrafService} from '../../../general-services/service-provider-anagraf/provider-anagraf.service';
import {LoaderService} from '../../../general-services/service-loader/loader.service';

@Component({
  selector: 'app-edit-provider-anagraf',
  templateUrl: './edit-provider-anagraf.component.html',
  styleUrls: ['./edit-provider-anagraf.component.scss']
})
export class EditProviderAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {

  providerType: ProviderModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;

  parameterSubscribe: Subscription;
  saveSubscribe: Subscription;
  submitted = false;

  id: number;
  providerCod: string;
  description: string;
  providerJson: any;

  constructor(private route: ActivatedRoute, private router: Router,
              private providerService: ProviderAnagrafService, private _activatedRoute: ActivatedRoute,
              private loaderService: LoaderService) {
    super();

    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.providerJson = params['row'];
      });

    this.providerType = new ProviderModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [{value: '', disabled: false}, Validators.required],
      description: [{value: '', disabled: false}, Validators.required]
    });
    this.providerType = JSON.parse(this.providerJson) as ProviderModel;

    this.formValidator.patchValue({
      cod: this.providerType ? this.providerType.cod : ''
    });

    this.formValidator.patchValue({
      description: this.providerType ? this.providerType.description : ''
    });

    _activatedRoute.params.subscribe(params => {
      this.id = params['id'];
      this.providerCod = params['cod'];
      this.description = params['description'];
    });
  }

  ngOnInit() {
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.PROVIDER_ANAGRF]);
  }

  edit() {
    this.submitted = true;
    if (this.formValidator.valid) {
      this.providerType.cod = this.formValidator.controls['cod'].value;
      this.providerType.description = this.formValidator.controls['description'].value;
      this.saveSubscribe = this.providerService.update(this.providerService.baseUrl, this.providerType).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Provider Cod already exists', 'Warning');
          } else if (result === -2) {
            toastr.options.timeout = 5000;
            toastr.warning('Element already used', 'Warning');
          } else {
            toastr.success('Provider was edited with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.PROVIDER_ANAGRF]);
          }
        }, error => {
          this.loaderService.display(false);
          toastr.error('Element has not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.formValidator.controls; }

}
